import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom'
import './index.css';
import '../node_modules/semantic-ui-css/semantic.min.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';


ReactDOM.render((
    <HashRouter>
      <App />
    </HashRouter>
), document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js